module.exports = __webpack_public_path__ + "static/media/visionarieslogo.bfdbd761.jpg";